import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let value = useDataValue({
    viewPath: props.viewPath,
    context: 'question',
    path: 'depends_on',
  })

  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'question',
    path: 'depends_on',
  })

  return function onClick() {
    let newValue = Array.isArray(value) ? [...value] : []

    newValue.push({
      id: '',
      validation: 'equals',
      value: '',
    })

    change(newValue)
  }
}
